export const tableStyles = {
  // Container styles
  container: {
    border: '1px',
    borderColor: '#E2E8F0',
    borderRadius: 'lg',
    bg: '#FFFFFF',
    boxShadow: 'sm',
  },

  // Scrollbar styles
  scrollbar: {
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E0',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#A0AEC0',
    },
  },

  // Table header styles
  thead: {
    position: 'sticky' as const,
    top: 0,
    zIndex: 10,
    backgroundColor: '#FAFAFA',
  },

  theadCell: {
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E7E8EB',
    fontSize: '13px',
    fontWeight: '600',
    color: '#2D3748',
    textTransform: 'none' as const,
    letterSpacing: 'normal',
    padding: '16px 20px',
  },

  // Table body styles
  tbody: {
    backgroundColor: '#FFFFFF',

  },

  tbodyCell: {
    fontSize: '14px',
    color: '#1A202C',
    padding: '16px 20px',
    borderBottom: '1px solid #E7E8EB',
  },

  tbodyRow: {
    backgroundColor: '#FFFFFF',
  },

  tbodyRowHover: {
    backgroundColor: '#FFFFFF',
  },

  // Pagination styles
  pagination: {
    container: {
      flexShrink: 0,
      px: 6,
      py: 4,
      borderTop: '1px',
      borderColor: '#E2E8F0',
    },
    
    button: {
      size: 'sm' as const,
      minW: '32px',
      h: '32px',
      fontSize: '14px',
    },

    activeButton: {
      bg: '#E53E3E',
      color: 'white',
      fontWeight: '600',
      _hover: { bg: '#C53030' },
    },

    inactiveButton: {
      bg: 'transparent',
      color: '#1A202C',
      fontWeight: '400',
      _hover: { bg: '#F7FAFC' },
    },

    navButton: {
      color: '#4A5568',
      _hover: { bg: '#F7FAFC' },
      _disabled: { opacity: 0.4, cursor: 'not-allowed' },
    },

    select: {
      size: 'sm' as const,
      w: '70px',
      fontSize: '14px',
      borderColor: '#E2E8F0',
      _hover: { borderColor: '#CBD5E0' },
      _focus: { borderColor: '#3182CE', boxShadow: '0 0 0 1px #3182CE' },
    },

    text: {
      fontSize: '14px',
      color: '#4A5568',
    },

    ellipsis: {
      fontSize: '14px',
      color: '#718096',
      px: 2,
    },
  },

  // Loading & Empty states
  loading: {
    spinner: {
      size: 'lg' as const,
      color: 'blue.500',
    },
    text: {
      fontSize: '14px',
    },
  },

  empty: {
    text: {
      fontSize: '14px',
    },
  },

  // Modal styles
  modal: {
    content: {
      borderRadius: 'lg',
    },
    header: {
      fontSize: '18px',
      fontWeight: '600',
    },
    body: {
      fontSize: '14px',
      color: '#4A5568',
    },
    button: {
      fontSize: '14px',
    },
    cancelButton: {
      _hover: { bg: '#F7FAFC' },
    },
  },

  // Colors
  colors: {
    tableBg: '#FFFFFF',
    borderColor: '#E2E8F0',
    theadBg: '#FAFAFA',
    spinnerColor: 'blue.500',
  },
}

export const tableColors = tableStyles.colors